import React from "react";
import { components as defaultReactSelectComponent } from "react-select";

export const OptionWithCheckBox = (props) => {
	if (props.value === "all") {
		let isAllChecked = props.getValue().length === props.options.length - 1;
		return (
			<defaultReactSelectComponent.Option {...props}>
				<input
					className="checkbox"
					type="checkbox"
					checked={isAllChecked}
					onChange={() => null}
				/>{" "}
				<label className="link">{props.label}</label>
			</defaultReactSelectComponent.Option>
		);
	}

	return (
		<defaultReactSelectComponent.Option {...props}>
			<input
				className="checkbox"
				type="checkbox"
				checked={props.isSelected}
				disabled={props.isDisabled}
				onChange={() => null}
			/>{" "}
			<label className="!text-[#222230]">{props.label}</label>
		</defaultReactSelectComponent.Option>
	);
};

export const customStyles = {
	option: (provided, state) => ({
		...provided,
		color:
			state.isFocused || state.isSelected
				? "var(--c-purple-400)"
				: "var(--c-grey-800)",
		backgroundColor: state.isFocused
			? "var(--c-grey-300)"
			: state.isSelected
				? "var(--c-grey-200)"
				: "none",
		padding: "var(--s-10)",
		"&:active": {
			backgroundColor: state.isDisabled ? "none" : "var(--c-grey-400)",
		},
		".link": {
			color: "var(--c-primary)",
		},
	}),
	placeholder: (provided) => ({
		...provided,
		font: "inherit",
		fontSize: "14px",
	}),
	menuList: (provided) => ({
		...provided,
		fontSize: "14px",
	}),
	control: (provided, state) => ({
		...provided,
		font: "inherit",
		fontSize: "14px",
		border: state.isFocused
			? "1px solid var(--c-input-border-focus)"
			: "1px solid var(--c-input-border)",
		borderRadius: "2px",
		boxShadow: "none",
		minHeight: "40px",

		"&:hover": {
			border: "1px solid var(--c-input-border-focus)",
		},
	}),
	input: (provided) => ({
		...provided,
		caretColor: "var(--c-primary)",
		"& input": {
			font: "inherit",
			fontSize: "10px",
		},
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		color: state.isFocused
			? "var(--c-input-border-focus)"
			: "var(--c-grey-500)",
		"&:hover": {
			color: "var(--c-input-border-focus)",
		},
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		backgroundColor: "transparent",
	}),
	clearIndicator: (provided) => ({
		...provided,
		cursor: "pointer",
		color: "var(--c-grey-500)",
		"&:hover": {
			color: "var(--c-input-border-focus)",
		},
	}),
	singleValue: (provided) => {
		return { ...provided };
	},
	multiValue: (provided) => ({
		...provided,
		fontSize: "16px",
	}),
	menuPortal: (styles) => ({
		...styles,
		zIndex: 99999,
	}),
};

export function getReactSelectStyles(error, styles = {}) {
	return {
		...customStyles,
		control: (provided, state) => ({
			...customStyles.control(provided, state),
			border: state.isFocused
				? "1px solid var(--c-input-border-focus)"
				: error
					? "1px solid var(--c-status-error)"
					: "1px solid var(--c-input-border)",
			...styles,
		}),
	};
}
